/**
 * Cinematic media manifest.
 * Every asset is generated (Higgsfield) — no stock imagery.
 *
 * Sources resolve local-first (`/media/*`) and fall back to the CDN,
 * so the site works immediately and can be fully localized by running
 * `app/scripts/fetch-media.sh` once.
 */

const CDN =
  'https://d8j0ntlcm91z4.cloudfront.net/user_3DPZqBHRQ6CaKiLpypvO9boACay';

export interface Scene {
  /** local filename under /media */
  local: string;
  /** remote mp4 fallback */
  remote: string;
  /** poster image (remote webp, small) */
  poster: string;
  /** full-res still (remote png) */
  still: string;
}

const still = (ts: string, id: string) => `${CDN}/hf_20260714_${ts}_${id}.png`;
const min = (ts: string, id: string) => `${CDN}/hf_20260714_${ts}_${id}_min.webp`;
const mp4 = (ts: string, id: string) => `${CDN}/hf_20260714_${ts}_${id}.mp4`;

/** Standalone cinematic stills (Higgsfield, same grade as the film scenes). */
export const STILLS = {
  patagonia: `${CDN}/hf_20260717_091613_b868db71-ecb9-44c2-95f6-b34914c501bd_min.webp`,
  registerHero: `${CDN}/hf_20260723_160847_5c63910a-f460-479a-9a2e-9d9b194bc551_min.webp`,
};

export const SCENES: Record<
  'hero' | 'plan' | 'explore' | 'memories' | 'collab',
  Scene
> = {
  hero: {
    local: '/media/hero.mp4',
    remote: mp4('100501', 'aeb0855e-0348-492d-8bb4-5d89a21d67e7'),
    poster: min('100235', '00948725-394c-4953-9335-c9eeda594380'),
    still: still('100235', '00948725-394c-4953-9335-c9eeda594380'),
  },
  plan: {
    local: '/media/plan.mp4',
    remote: mp4('100439', 'afabf122-0d30-4299-9349-d72b264a5d56'),
    poster: min('100247', '6b8a96a9-0472-42b0-a00d-83acc5a1894c'),
    still: still('100247', '6b8a96a9-0472-42b0-a00d-83acc5a1894c'),
  },
  explore: {
    local: '/media/explore.mp4',
    remote: mp4('100442', '3d7f0417-8264-4d12-8436-cc33d0f9a466'),
    poster: min('100249', 'ccdf390c-194e-41e4-b13f-871e2f4fb6a4'),
    still: still('100249', 'ccdf390c-194e-41e4-b13f-871e2f4fb6a4'),
  },
  memories: {
    local: '/media/memories.mp4',
    remote: mp4('100503', '4055c1f8-f40e-4c39-9c18-3b9c2c697d98'),
    poster: min('100252', '77ea7b8e-4a97-4e12-9cf2-b3d2da674ffc'),
    still: still('100252', '77ea7b8e-4a97-4e12-9cf2-b3d2da674ffc'),
  },
  collab: {
    local: '/media/collab.mp4',
    remote: mp4('100450', '298bbe9b-01cb-4efa-b70b-834f1a755bf4'),
    poster: min('100255', '97b33c28-494d-4057-8197-6cebfb2c9ef2'),
    still: still('100255', '97b33c28-494d-4057-8197-6cebfb2c9ef2'),
  },
};
